import { Medal } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/atoms/Avatar";
import { cn } from "@/utils/cn";
import type { RankingRow } from "@/modules/leagues/types/ranking";

const MEDAL_COLOR: Record<number, string> = {
  1: "text-accent-700 dark:text-accent-300",
  2: "text-muted-foreground",
  3: "text-amber-700 dark:text-amber-400",
};

export function RankingRowItem({ row, liveBoost }: { row: RankingRow; liveBoost?: number }) {
  const initials = row.nome
    .split(" ")
    .slice(0, 2)
    .map((n) => n[0])
    .join("");

  return (
    <div
      className={cn(
        "flex items-center gap-3 rounded-xl px-3 py-2.5",
        row.posicao <= 3 ? "bg-accent-50 dark:bg-accent-500/10" : "bg-card border border-border"
      )}
    >
      <div className="flex w-6 shrink-0 items-center justify-center">
        {row.posicao <= 3 ? (
          <Medal className={cn("h-4 w-4", MEDAL_COLOR[row.posicao])} />
        ) : (
          <span className="font-display text-xs font-bold text-muted-foreground">{row.posicao}</span>
        )}
      </div>
      <Avatar size="sm">
        {/* Foto real do usuário quando ele escolheu uma — só cai pras
            iniciais (comportamento de sempre) se `avatarUrl` for nulo, ou
            se a imagem falhar ao carregar (AvatarImage já trata isso
            sozinho, mesmo padrão usado em todo o resto do app). */}
        <AvatarImage src={row.avatarUrl ?? undefined} alt={row.nome} />
        <AvatarFallback>{initials}</AvatarFallback>
      </Avatar>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium">{row.nome}</p>
        <p className="text-[11px] text-muted-foreground">
          {row.acertosPlacar} placares exatos · {row.percentualAcerto}% de acerto
        </p>
      </div>
      <div className="flex flex-col items-end">
        <span className="font-display text-sm font-bold tabular-nums">{row.pontos}</span>
        {liveBoost !== undefined && liveBoost > 0 && (
          <span className="flex items-center gap-1 text-[10px] font-semibold text-emerald-700 dark:text-emerald-400">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> +{liveBoost} ao vivo
          </span>
        )}
      </div>
    </div>
  );
}
